import {useHubQuery} from '../../QueryProvider'

/**
 * Hook to fetch the latest order change request with extended status.
 *
 * Uses: GET /OrderManagement/v2/Change/{orderId}/requests?latestRequestOnly=true&extend=StatusWithAppliedChanges
 *
 * This is used to:
 * 1. Check if there's a pending change request for an order
 * 2. Determine if changes have been applied yet (changesApplied field)
 * 3. Show appropriate banner in OrderDetailsSM
 *
 * @param orderId - The order ID to fetch the latest change request for
 * @param enabled - Whether to enable the query (default: true)
 * @param refetchInterval - Polling interval in ms (default: false = no polling)
 */
export const useGetLatestOrderChangeRequest = (
  orderId: string,
  enabled = true,
  refetchInterval: number | false = false
) => {
  return useHubQuery('latestOrderChangeRequest', [orderId], {
    enabled: !!orderId && enabled,
    refetchOnWindowFocus: true,
    refetchOnMount: 'always',
    staleTime: 0, // Always consider data stale to ensure fresh fetch
    refetchInterval,
    // Don't retry on 404 (no request found is a valid state)
    retry: (failureCount, error) => {
      if ((error as {response?: {status?: number}})?.response?.status === 404) {
        return false
      }
      return failureCount < 3
    }
  })
}
